import { render, staticRenderFns } from "./e-sign-add-template-data-page.vue?vue&type=template&id=3c4a7fcd"
import script from "./e-sign-add-template-data-page.vue?vue&type=script&lang=js"
export * from "./e-sign-add-template-data-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports